import {
  Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, EventEmitter
} from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { AirValidationResponseVm, AirValidationSectorVm } from '@app/entities/air-validation.response';
import { MobileSectorVm } from '@app/entities/flight-results';
import { isNullOrUndefined } from '@app/util/util';
import { TravelDetailProvider } from '@shared/flight-itinerary/entities/travel-detail-provider';
import { ReservationFlight } from '@user-history/entities/history-booking-detail';
import { ReservationStatus } from '@user-history/entities/reservation-status';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';
import { 
  TypographyColor, TypographyFontFamily, TypographyFontSize 
} from '@design-system/components/atoms/typography/entities/typography.types';
import { GenericCardSpaces } from '@design-system/components/templates/generic-card/entities/generic-card.types';

@Component({
  selector: 'app-flight-small-reservation',
  templateUrl: './flight-small-reservation.component.html',
  styleUrls: ['./flight-small-reservation.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FlightSmallReservationComponent {

  @Input() validationVm: ReservationFlight;
  @Input() summaryProvider: TravelDetailProvider;
  @Input() referenceCode: string;
  @Input() isBySectorTemplate: boolean = false;
  @Input() multipleOneWay: boolean = false;
  @Input() index: number | null = null;
  @Input() isPendingChange = false;
  
  @Output() showMoreInfo: EventEmitter<{ validator: AirValidationResponseVm, sectorNumber: number }> = new EventEmitter();
  
  public readonly genericCardSpaces = GenericCardSpaces;
  
  public readonly icon = Icon;
  
  public readonly fontFamily = TypographyFontFamily;
  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;
  
  constructor(
    private translateService: TranslocoService
  ) { }

  get multipleOneWayKeyActive(): boolean {
    return !!this.isBySectorTemplate && !!this.multipleOneWay && !isNullOrUndefined(this.index);
  }

  get reservationCodeValidate(): boolean {
    return !!this.referenceCode && !this.isPendingChange;
  }

  get titleLabel(): string {
    const multipleOneWayKeyBase = 'USER_HISTORY_MODULE.DETAIL';
    const key = this.multipleOneWayKeyActive ?
      this.index === 0 ? `${multipleOneWayKeyBase}.DEPARTURE_TRIP` :
        `${multipleOneWayKeyBase}.RETURN_TRIP` :
      'PACKAGES_MODULES.PACKAGE_BOOKING.YOUR_TRIP';
    const translate = this.translateService.translate(key);
    return this.multipleOneWayKeyActive ? `${translate}:` : translate;
  }

  get isDepartureIcon(): boolean {
    return this.index === 0;
  }

  public statusLabel(status: ReservationStatus): ReservationStatus {
    return (status === ReservationStatus.OnHold || status === ReservationStatus.Processing) && 
    this.isPendingChange ? ReservationStatus.PendingChange: status;
  }

  public trackById(index: number, sector: AirValidationSectorVm): string {
    return `${index}-${sector.SectorNumber}`;
  }

  public getSectorNumber(sectorNumber: number): number {
    return this.multipleOneWayKeyActive ? this.index + 1 : sectorNumber;
  }

  public getSector(sector: MobileSectorVm): MobileSectorVm {
    return { ...sector, SectorNumber: this.getSectorNumber(sector.SectorNumber) } as MobileSectorVm;
  }

  public showMoreInfoEvent(validator: AirValidationResponseVm, sectorNumber: number): void {
    if (this.multipleOneWayKeyActive && isNullOrUndefined(sectorNumber)) {
      this.showMoreInfo.emit({ validator, sectorNumber: this.index + 1 });
    } else this.showMoreInfo.emit({ validator, sectorNumber });
  }

}
